import styled from '@emotion/styled'
import * as v from 'variables/styled'

export const GeneralInformationContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',

  '.rowFields': {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
  },
})

export const SubDetailContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  marginTop: '1rem',

  '.subTitle': {
    borderBottom: `solid ${v.borderGray} 1px`,
    fontSize: '1.5rem',
    fontWeight: 'bold',
    paddingBottom: '0.25rem',
    marginBottom: '1rem',
  },

  '.ReactTable': {
    width: '-webkit-fill-available',
    height: 'fit-content',
    marginTop: '1rem',
    borderRadius: '5px',
  },

  '.ui.table td': {
    padding: '5px',
    borderRight: '1px solid rgba(34,36,38,.1)',
  },

  '.ui.table td:last-child': {
    borderRight: 'none',
  },

  '.ui.table thead th': {
    padding: '8px',
    borderRight: '1px solid rgba(34,36,38,.1)',
  },

  '.ui.table thead th:last-child': {
    borderRight: 'none',
  },
})

export const TableData = styled.div({
  display:'flex', 
  flexDirection:'column', 
  // marginTop:'1rem',

  '.require':{
    color:'red',
    fontSize:'1.5rem'
  },

  '.tbHeader':{
    fontWeight:'bold',
    border: `0.1rem solid ${v.borderGray}`,
    padding:'0.5rem 0.5rem'
  },
  '.tbRow':{
    fontWeight:'bold',
    border: `0.1rem solid ${v.borderGray}`,
    borderTop:'0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '.fieldRow':{
      margin:'0 !important'
    },
    'input':{
      border:'none !important',
      padding:'0.1rem !important'
    },
    '.fieldInput':{
      'div:first-child':{
        border:'none !important',
      },
      '.ui.search.selection.dropdown>input.search':{
        marginTop:'0.5rem'
      }
    }
  },

  '.tbRowL':{
    fontWeight:'bold',
    border: `0.1rem solid ${v.borderGray}`,
    borderTop:'0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '.fieldRow':{
      margin:'0 !important'
    },
    'input':{
      border:'none !important',
      padding:'0.1rem !important',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    '.fieldInput':{
      'div:first-child':{
        border:'none !important',
      },
      '.ui.search.selection.dropdown>input.search':{
        marginTop:'0.5rem'
      }
    }
  },

  'div:first-child':{
    'div:first-child':{
      borderTopLeftRadius:'0.5rem'
    },
    'div:last-child':{
      borderTopRightRadius:'0.5rem'
    }
  },
  'div:last-child':{
    'div:first-child':{
      borderBottomLeftRadius:'0.2rem'
    },
    'div:last-child':{
      borderBottomRightRadius:'0.2rem'
    }
  }
})